import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { ApiRoutes } from "./Routes";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const handleSubmit = () => {
    var _a, _b, _c;
    const fetcher = fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.SymantecEDR.CHECK_CREDENTIALS), {
      management_ip: ((_a = formData == null ? void 0 : formData.managementIP) == null ? void 0 : _a.value) || "",
      client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Symantec EDR using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Symantec EDR using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(
    ["symantecEDRName", "managementIP", "clientId", "clientSecret"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "symantecEDRName",
        type: "text",
        fieldData: formData.symantecEDRName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "managementIP",
        type: "text",
        fieldData: formData.managementIP,
        onChange,
        label: "Management Server Host",
        help: "The IP address or host name of your Symantec EDR Management server",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        label: "Client ID",
        help: "The GUID of the client to which the content belongs.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: "Client Secret",
        help: "A secret string of the user to prove its identity when requesting a token.",
        required: true
      }
    )
  );
};
export default StepAuthorize;
